export default {
      id: "short-edit-icon-primary-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#short-edit-icon-primary-usage",
      toString: function () {
        return this.url;
      }
    }